import RestRequestFactory from '@utils/network/RestRequestFactory';
import config from '@config';

const baseURL = process.env.NODE_ENV === 'development' ? '' : config.services.videoStreams.host;

export default class RestService {

    constructor(private request = RestRequestFactory.create(baseURL)) {
    }

    public async getMatchVideoStreamData(streamSourceId: number, matchId: any) {
        const response = await this.request.get('/rest/SBWeb.Models.Offer/startStreaming', {
            params: {
                streamSourceId,
                matchId,
            }
        }) as any;

        if (response.success) {
            return response;
        }
        throw response;
    }

    public async getImgStream(matchId: number, {
        url,
        clientId,
        timems,
        md5,
    } : {
        url: string,
        clientId: number,
        timems: number,
        md5: string
    }) {
        const response = await this.request.get(`${url}/api/v2/streaming/events/${matchId}/stream`, {
            params: {
                operatorId: clientId,
                auth: md5,
                timestamp: timems,
                // hardcoded
                'page.page': 2,
                'page.size': 1,
            }
        }) as any;
        if ((response.success === undefined && response.hlsUrl) || response.success) {
            return response;
        }
        throw response;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/media/_private/RestService.ts